import React, { useState } from 'react';

import { planogramsModel } from 'models';
import { PlanogramVersion } from 'types';
import { SphereLoader } from 'types/sphereLoader';
import SphereLoaderCard from 'components/SphereLoaderCard/SphereLoaderCard';

interface SphereLoaderProps {
  planogramVersion: PlanogramVersion;
  planogramId: number;
  handleServerError: (err: any) => void;
  setSuccessActionMessages: (messages: string[]) => void;
}

const defaultSettings = {
  enabled: false,
  otherAsset: null
};

export const SphereLoaderSettings = ({
  planogramId,
  planogramVersion,
  handleServerError,
  setSuccessActionMessages
}: SphereLoaderProps) => {
  const [sphereLoaderSettings, setSphereLoaderSettings] = useState<SphereLoader>(
    planogramVersion.sphereLoader ?? defaultSettings
  );
  const handleSave = async (settings: SphereLoader) => {
    const { otherAsset, ...rest } = settings;
    const dataToSave = {
      ...rest
    };

    if (otherAsset?.id) {
      dataToSave.otherAssetId = otherAsset.id;
    }

    return planogramsModel
      .editVersion(planogramId, planogramVersion.id, { sphereLoader: dataToSave })
      .then(data => {
        setSuccessActionMessages(data.success);
        setSphereLoaderSettings(data.planogramVersion.sphereLoader);
      })
      .catch(handleServerError);
  }

  return (
    <SphereLoaderCard
      settings={sphereLoaderSettings}
      handleServerError={handleServerError}
      onSettingsSave={handleSave}
    />
  )
}
